module.exports = __webpack_public_path__ + "img/bag.ba6d97a0.svg";